
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/pageSettingsPanel/settings/tabs/PageSettingsPermissionsTab/PermissionsTabComponents/membersAccessTypes.scss.css.virtualfile';
        module.exports = {"memberAccessTypes":"_memberAccessTypes_ewvan_1","accessLabel":"_accessLabel_ewvan_4"};